import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
import { Button, Row } from 'reactstrap';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';

// Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';
import mascaras from '../../../helpers/mascaras';

export default function RelatorioGeradoresPontoColetas({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();

    const refRelatorio = useRef();

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);

    const [dados, setDados] = useState([])

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetasNaoRealizadas = [
        { value: "RAZÃO SOCIAL", objectValue: "razaoSocial", col: "4" },
        { value: "NOME FANTASIA", objectValue: "fantasia", col: "4" },
        { value: "CNPJ", objectValue: "cnpj", col: "4" },

        { value: "STATUS GERADOR", objectValue: "status", col: "4" },
        { value: "RAMO DE ATIVIDADE", objectValue: "ramoAtividade", col: "4" },

        { value: "ENDEREÇO DE COLETA", objectValue: "endereco", col: "8" },
        { value: "REGIONAL", objectValue: "regional", col: "4" },

        { value: "MODALIDADE", objectValue: "modalidade", col: "4" },
        { value: "STATUS CONTRATO DE COLETA", objectValue: "statusContrato", col: "4" },
        { value: "TRANSPORTADOR", objectValue: "transportador", col: "4" },

        { value: "INÍCIO DA VIGÊNCIA", objectValue: "inicioVigencia", col: "4" },
        { value: "FINAL DA VIGÊNCIA", objectValue: "fimVigencia", col: "4" },
        { value: "DATA VENCIMENTO", objectValue: "dataValidade", col: "4" },
    ];

    const headersCSV = [
        { label: "RAZÃO SOCIAL", key: "razaoSocial" },
        { label: "NOME FANTASIA", key: "fantasia" },
        { label: "CNPJ", key: "cnpj" },
        { label: "STATUS GERADOR", key: "status" },
        { label: "ENDEREÇO DE COLETA", key: "endereco" },
        { label: "REGIONAL", key: "regional" },
        { label: "STATUS CONTRATO DE COLETA", key: "statusContrato" },
        { label: "TRANSPORTADOR", key: "transportador" },
        { label: "MODALIDADE", key: "modalidade" },
        { label: "RAMO DE ATIVIDADE", key: "ramoAtividade" },
        { label: "INÍCIO DA VIGÊNCIA", key: "inicioVigencia" },
        { label: "FINAL DA VIGÊNCIA", key: "fimVigencia" },
        { label: "DATA VENCIMENTO", key: "dataValidade" },
    ];

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório geradores pontos de coletas",
    });

    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }

    useEffect(() => {
        if (dadosRelatorio?.length > 0) {
            setDados([...dadosRelatorio.map(value => {
                value.cnpj = mascaras.cpfcnpjMask(value.cnpj)
                return value;
            })])
        }
    }, []);

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink
                separator={";"}
                data={dados}
                headers={headersCSV}
                filename="Relatorio de transportadores.csv"
                target="_blank"
                ref={exportRef}
            />
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} width={250} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de Geradores por Ponto de Coleta</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    {!!filtros.cnpj &&
                        <Row>
                            <div className='col-4'>
                                <p><span className="fw-bold">CPF/CNPJ:</span> {mascaras.cpfcnpjMask(filtros.cnpj)}</p>
                            </div>
                        </Row>
                    }
                    <Row>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected && <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>}
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Lista de Geradores</h5>
                    <CardRelatorio
                        headers={headersColetasNaoRealizadas}
                        items={dados}
                    />
                </div>
            </div>
        </MainCard>
    );
}
